import type {StoreState} from '../store/storeReducer';

import {
  BUSINESS_LAW, 
  FORMATIONS, 
  LABOR_LAW, 
  type LawType,
} from '@dokia/domain-model';

const DOMAINE_LABELS = {
  [BUSINESS_LAW]: 'Droit des sociétés',
  [FORMATIONS]: 'Formations',
  [LABOR_LAW]: 'Droit du travail',
} as const satisfies Record<LawType, string>;

type UserTrackingContext = {
  domaine: null | string;
  firm_name: null | string;
  user_id: null | string;
};

export function buildUserTrackingContext(
  state: StoreState,
): UserTrackingContext {
  if (!state.isAuthenticated) {
    return {
      domaine: null,
      firm_name: null,
      user_id: null,
    };
  }

  const {selectedDomain, user} = state;

  return {
    domaine: DOMAINE_LABELS[selectedDomain],
    firm_name: user?.firm?.name ?? null,
    user_id: user?.documentId ?? null,
  };
}
